import type { ThemeConfig } from "antd";

const theme: ThemeConfig = {
  token: {
    colorPrimary: "#667FFF",
    colorLink: "#667FFF",
    borderRadius: 4,
    fontFamily: "Figtree",
    // Select multiple item text color
    colorWhite: "#ffffff",
  },
  components: {
    Menu: {
      darkSubMenuItemBg: "#1b2b4b",
      darkItemSelectedBg: "rgba(255,255,255,0.1)",
      darkItemSelectedColor: "#667FFF",
    },
    Select: {
      multipleItemBg: "#3D4D99",
      multipleItemBorderColor: "#3D4D99",
      optionSelectedColor: "#3D4D99",
      colorBorder: "#00000015",
      colorBgContainer: "#ffffff",
      selectorBg: "#ffffff",
      colorText: "#000000",
      colorIcon: "#ffffff",
      colorTextDisabled: "#999999",
    },
    Dropdown: {
      paddingBlock: 16,
    },
    Table: {},
    Tag: {
      borderRadiusSM: 20,
      colorText: "#666666",
      colorIcon: "#666666",
      colorBgContainer: "#F7F7F7",
    },
    Tabs: {
      itemActiveColor: "#ffffff",
      itemHoverColor: "#3d4d99",
      itemSelectedColor: "#ffffff",
      inkBarColor: "#ffffff",
      itemColor: "#666666",
      colorBgContainer: "#3d4d99",
      colorBorder: "transparent",
    },
    Input: {
      colorBorder: "#00000015",
    },
    DatePicker: {
      colorBorder: "#00000015",
    },
    Button: {
      colorBorder: "#00000015",
    },
  },
};

export default theme;
